import * as Sentry from "@sentry/react-router"
import { sentryBeforeSend } from "source/sentryBeforeSend"

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: ["prototype", "staging", "production"].includes(
    import.meta.env.VITE_ACTIVE_ENV,
  ),
  environment: import.meta.env.VITE_ACTIVE_ENV,
  release: import.meta.env.VITE_SOURCE_VERSION || "unknown_version",
  normalizeDepth: 5,
  beforeSend: sentryBeforeSend,
  ignoreErrors: [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed",
  ],
})
